<header id="main-site-header" class="shadow-sm" style="display: flex; flex-direction: column-reverse; justify-content: center; align-items: center; gap: 15px; height: auto; padding: 19px 0;">
  <div id="logos" class="d-flex align-items-center gap-3 flex-shrink-0 flex-wrap" style="justify-content:center; gap:15px;">
    <a routerLink="/home" aria-label="Inicio">
      <img src="assets/images/logoministerio1.png" alt="Logo" height="90">
    </a>
    <a routerLink="/home" aria-label="Inicio">
      <img src="assets/images/logorepo1.png" alt="Logo repositorio" height="75" />
    </a>
    <a routerLink="/home" aria-label="Inicio">
      <img src="assets/images/logo_oap.png" alt="Logo" height="90">
    </a>
  </div>
  <div class="container d-flex align-items-center justify-content-around">
    <nav class="d-none d-md-flex" aria-label="Navegación principal">
      <ds-navbar></ds-navbar>
    </nav>
    <div class="d-lg-none">
        <button class="btn btn-outline-secondary" (click)="toggleNavbar()"
                aria-label="Menú móvil" [attr.aria-expanded]="(isNavBarCollapsed$ | async) !== true">
          <i class="fas fa-bars"></i>
        </button>
      </div>
    <div class="d-flex align-items-center gap-5 flex-shrink-0">
      <div>
        <ds-lang-switch></ds-lang-switch>
      </div>
      <div>
        <ds-auth-nav-menu></ds-auth-nav-menu>
      </div>
    </div>
  </div>
</header>

